import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='retirement-planning-faq' // '-section-container' will be appended dynamically
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about retirement planning&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-retirement-planning'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'retirement-planning-how-advisor-can-help-with-retirement-planning',
              title: (<>How can an advisor help me with <WidowBlock>retirement planning&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    No matter where you&#39;re starting from, our advisors can show you the right financial steps to take you closer to the retirement you want. They&#39;ll think of all the what&#45;ifs so you don&#39;t have to and create a plan (at no cost to you) tailored from a range of top&#45;rated financial solutions designed to give you the flexibility and confidence to reach your retirement goals. Ready to get started&#63;{' '}
                    <Link
                      id='retirement-planning-faq-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-key-aspects-of-retirement-planning',
              title: (<>What are the key aspects of <WidowBlock>retirement planning&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Depending on how you want to spend your retirement years, our advisors will help you figure out the right strategies to make it happen. From 401(k)s, IRAs, investments, and annuities to the right types of insurance, we&#39;ll help make the most of your retirement while still enjoying your life today.{' '}
                    <Link
                      id='retirement-planning-faq-key-aspects-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with a financial advisor to get started
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-who-should-consider-planning-services',
              title: (<>Who should consider retirement <WidowBlock>planning services&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Anyone who would like to retire how they want, where they want, when they want. No matter where you&#39;re starting from, our advisors are here to show you the right financial steps to take so you can have the retirement you&#39;ve always dreamed of. Sound good&#63;{' '}
                    <Link
                      id='retirement-planning-faq-who-should-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor today
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-how-much-do-you-need-to-retire',
              title: (<>How much do you need <WidowBlock>to retire&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    In general, people aim to replace around 80&#37; of their pre&#45;retirement income. The actual number will depend on things like when you want to retire, where you&#39;ll live, and what kind of lifestyle you want to maintain throughout your retirement years.{' '}
                    <Link
                      id='retirement-planning-faq-retirement-calculator-link'
                      linkUrl='/retirement-planning/retirement-calculator/'
                      variant='primaryDeemphasize'>
                      Get a snapshot of the income you could have and may need in retirement
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-best-retirement-plans',
              title: (<>What are the best <WidowBlock>retirement plans&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    The best plan is one that is designed specifically for you and your goals.{' '}
                    <Link
                      id='retirement-planning-faq-401k-plans-link'
                      linkUrl='/401k-plans/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about 401k plans'>
                      401&#40;k&#41;s
                    </Link>
                    ,{' '}
                    <Link
                      id='retirement-planning-faq-iras-and-retirement-plans-link'
                      linkUrl='/iras-and-retirement-plans/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about IRAs and retirement plans'>
                      individual retirement accounts &#40;IRAs&#41;
                    </Link>
                    ,{' '}
                    <Link
                      id='retirement-planning-faq-what-is-a-sep-ira-link'
                      linkUrl='/life-and-money/what-is-a-sep-ira/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about SEP IRAs'>
                      SEP IRA
                    </Link>
                    ,{' '}
                    <Link
                      id='retirement-planning-faq-what-is-a-solo-401k-link'
                      linkUrl='/life-and-money/what-is-a-solo-401k/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about Solo 401k plans'>
                      Solo 401&#40;K&#41;
                    </Link>
                    , and Simple IRA, and are probably the most well&#45;known types of retirement accounts. But just because they&#39;re the most common doesn&#39;t mean they&#39;re your only options. Our plans are tailored to fit you with a range of financial options. From{' '}
                    <Link
                      id='retirement-planning-faq-insurance-link'
                      linkUrl='/insurance/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about insurance'>
                      insurance
                    </Link>
                    {' '}for protection &#40;and in some cases building a cash value<sup>2</sup>&#41; to{' '}
                    <Link
                      id='retirement-planning-faq-investments-link'
                      linkUrl='/investments/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about investments'>
                      investments
                    </Link>
                    {' '}to help your money grow to{' '}
                    <Link
                      id='retirement-planning-faq-annuities-link'
                      linkUrl='/annuities/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about income annuities'>
                      income annuities
                    </Link>
                    {' '}for a guaranteed income stream, we&#39;ll help you live the retirement you always wanted. There&#39;s a range of employer&#45;sponsored and personal accounts that you might be able to use in your overall retirement plan.{' '}
                    <Link
                      id='retirement-planning-faq-9-types-of-retirement-accounts-you-should-know-link'
                      linkUrl='/life-and-money/9-types-of-retirement-accounts-you-should-know/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about what other types of retirement accounts you can consider'>
                      See which ones you can consider
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-when-to-start-planning',
              title: (<>When should I start <WidowBlock>retirement planning&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    The important thing{' '}
                    <Link
                      id='retirement-planning-faq-how-do-i-start-planning-for-retirement-link'
                      linkUrl='/life-and-money/how-do-i-start-planning-for-retirement/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about how to start planning for retirement'>
                      is that you start
                    </Link>
                    &#8212;no matter if you&#39;re decades away from retirement or a few years. Giving yourself as much time as possible will certainly be an advantage. More time will give you more flexibility to save and shape your retirement plan. Still, even if you&#39;re getting a late start, there&#39;s still time to make the most of what you have.{' '}
                    <Link
                      id='retirement-planning-faq-when-to-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with a financial advisor to get started
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-how-to-start-planning',
              title: (<>How can I get started with <WidowBlock>retirement planning&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    It&#39;s easy. The very first step is to{' '}
                    <Link
                      id='retirement-planning-faq-how-to-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      get matched with the right advisor
                    </Link>
                    {' '}for you. And the first thing they&#39;ll do is ask the right questions to understand what&#39;s most important to you. Then they&#39;ll tailor your plan to help you retire the way you want.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-outlive-my-retirement',
              title: (<>What if I outlive my <WidowBlock>retirement savings&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Making your money last throughout retirement starts with a smart retirement plan. A key part of it should be a plan for withdrawing your savings in retirement. One well&#45;known general guideline is the{' '}
                    <Link
                      id='retirement-planning-faq-xxx-link'
                      linkUrl='/life-and-money/how-does-the-4-percent-rule-work-for-retirement/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about the 4 percent rule'>
                      4 percent rule
                    </Link>
                    . It provides a framework with a customized strategy for being reasonably confident that your money will last as long as you do. Our version of planning looks at your big picture then tailors a plan to fit your priorities. Your retirement plan may include an{' '}
                    <Link
                      id='retirement-planning-faq-second-investments-link'
                      linkUrl='/investments/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about investment strategies'>
                      investment strategy
                    </Link>
                    {' '}to grow your money, the{' '}
                    <Link
                      id='retirement-planning-faq-second-insurance-link'
                      linkUrl='/insurance/'
                      variant='primaryDeemphasize'>
                      right types of insurance
                    </Link>
                    {' '}to protect what you already have, and{' '}
                    <Link
                      id='retirement-planning-faq-second-annuities-link'
                      linkUrl='/annuities/'
                      variant='primaryDeemphasize'>
                      income annuities
                    </Link>
                    {' '}to make sure you have a steady income stream that cannot be outlived.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-plan-for-medical-expenses',
              title: <>Can an advisor help me plan for <WidowBlock>medical expenses&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Yes. Many people underestimate the costs of{' '}
                    <Link
                      id='retirement-planning-faq-first-long-term-care-link'
                      linkUrl='/long-term-care-planning/'
                      variant='primaryDeemphasize'>
                      long&#45;term care
                    </Link>
                    . They&#39;re often higher than you&#39;d expect&#8212;and on the rise. Our advisors will create a plan for your long&#45;term care that can help you get the quality care you need at home or in a facility you want, without having to use up your retirement income or assets. Talk to an advisor about your options.{' '}
                    <Link
                      id='retirement-planning-faq-plan-for-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched today.
                    </Link>
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-qualified-retirement-plan',
              title: <>A qualified retirement plan&#63; <WidowBlock>What&#39;s that&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    This is a plan the IRS has ok&#39;d to allow money you invest to{' '}
                    <Link
                      id='retirement-planning-faq-how-different-types-of-retirement-savings-are-taxed-link'
                      linkUrl='/life-and-money/how-different-types-of-retirement-savings-are-taxed/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about how different types of retirement savings are taxed'>
                      grow tax deferred
                    </Link>
                    . Most retirement plans offered through work, think a 401(k) and 403(b), are qualified plans. Individual retirement accounts (IRAs), pension plans, and Keogh plans are also examples. But just because they&#39;re the most common doesn&#39;t mean they&#39;re your only options. There&#39;s a range of employer&#45;sponsored and personal accounts that you might be able to use in your overall retirement plan.{' '}
                    <Link
                      id='retirement-planning-faq-see-the-9-types-of-retirement-accounts-you-should-know-link'
                      linkUrl='/life-and-money/9-types-of-retirement-accounts-you-should-know/'
                      variant='primaryDeemphasize'>
                      See which ones might be right for you
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-retirement-plan-cost',
              title: (<>What does a retirement <WidowBlock>plan cost&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    There are no initial costs for us to tailor a retirement plan for you. Some of our financial advisors do fee&#45;based planning, but they&#39;ll let you know that up front.{' '}
                    <Link
                      id='retirement-planning-faq-plan-cost-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Talk to one of our financial advisors
                    </Link>
                    {' '}about getting your retirement plan.
                  </Typography>
                </>
              ),
            },
            {
              id: 'retirement-planning-how-to-choose',
              title: (<>How do I choose the best life insurance for my <WidowBlock>retirement plan&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    The right type of insurance will depend on your retirement goals. It can simply be a safety net or much more than that. For example,{' '}
                    <Link
                      id='retirement-planning-faq-whole-life-insurance-link'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      whole life insurance
                    </Link>
                    {' '}builds cash value over time that you can use as additional income in retirement or for anything else you need throughout your life.<sup>2</sup>{' '}
                    <Link
                      id='retirement-planning-faq-how-to-choose-get-matched-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Talk to an advisor
                    </Link>
                    {' '}about which types of life insurance are best for you.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
